import styles from "./FJStockVideoHeaderOptions.module.less";
import React from "react";
import classNames from 'classnames';

function FJStockVideoHeaderOptions(props) {
	return (
		<div className={classNames(styles.options_item, {[styles.active]: props.active})}
				 ref={props.optionRef}
				 onClick={() => {
					 props.onClick(props.type)
				 }}
		>
			{props.icon}
			<span>{props.text}</span>
		</div>
	)
}


export default FJStockVideoHeaderOptions;